"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleLanguageTagMapper = void 0;
const LanguageTagMatcher_1 = require("./LanguageTagMatcher");
/**
 * The mapper is used to find the best matching article IETF language tag for the given IETF language tag.
 */
class ArticleLanguageTagMapper {
    /**
     * Constructor
     *
     * @param availableArticleLanguageTags The available article IETF language tags.
     * @param defaultArticleLanguageTags The default article IETF language tags sorted by priority.
     */
    constructor(availableArticleLanguageTags, defaultArticleLanguageTags) {
        this.availableArticleLanguageTags = availableArticleLanguageTags;
        this.defaultArticleLanguageTags = defaultArticleLanguageTags;
    }
    /**
     * Finds the best matching article IETF language tag for the given IETF language tag.
     * The returned article IETF language tag is from the list of available article IETF language tags.
     * If no match is found, then the first default article IETF language tag is returned.
     *
     * @param languageTag The IETF language tag that should be matched to a article IETF language tag.
     */
    mapLanguageTag(languageTag) {
        const matcher = new LanguageTagMatcher_1.LanguageTagMatcher(this.availableArticleLanguageTags, this.defaultArticleLanguageTags[0]);
        return matcher.findBestMatch(languageTag);
    }
}
exports.ArticleLanguageTagMapper = ArticleLanguageTagMapper;
//# sourceMappingURL=ArticleLanguageTagMapper.js.map